<template>
    <people :people="directorates" @updateChosen="chosen => chosenDirectorate = chosen">
        <template slot="chosen-card">
            <chosen-person v-if="chosenDirectorate.firstName"
                           :first-name="chosenDirectorate.firstName"
                           :last-name="chosenDirectorate.lastName"
                           :img="$helper.imgServerUrl() + userById[chosenDirectorate.ref_user_id].img"
                           :info-text="'<h2>'+chosenDirectorate.title+':</h2>'+chosenDirectorate.work_description">
            </chosen-person>
        </template>
    </people>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import People from "../content/club/people/People";
    import ChosenPerson from "../content/club/people/ChosenPerson";
    import {Resize, Scroll} from 'vuetify/es5/directives'

    export default {
        name: "DirectoratePage",
        components: {ChosenPerson, People},
        computed: {
            ...mapGetters(['directorates', 'userById'])
        },
        directives: {
            Resize, Scroll
        },
        data() {
            return {
                chosenDirectorate: {}
            }
        },
        methods: {
            ...mapActions(['getAllUsers', 'getDirectorate'])
        },
        mounted() {
            if (this.directorates.length === 0) {
                this.getAllUsers()
                this.getDirectorate()
            }
            setTimeout(() => {
                this.$vuetify.goTo(0, {offset: 0, duration: 300, easing: 'easeOutCubic'})
            }, 100)
        }
    }
</script>
